import React, { useState } from 'react';
import { Facebook, Twitter, Linkedin, Link2, Check, MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const ShareButtons = ({ className = '', variant = 'default' }) => {
  const { language } = useLanguage();
  const [copied, setCopied] = useState(false);
  
  const shareUrl = 'https://biosounds.es';
  const shareTitle = language === 'es' 
    ? 'BIOSOUNDS - Neurobiomodulación Sonora para tu Bienestar' 
    : 'BIOSOUNDS - Sound Neurobiomodulation for Your Wellbeing';
  const shareText = language === 'es'
    ? 'Descubre el poder de las frecuencias sonoras para mejorar tu sueño y reducir la ansiedad. Respaldado por más de 50 estudios científicos.'
    : 'Discover the power of sound frequencies to improve your sleep and reduce anxiety. Backed by over 50 scientific studies.';

  const handleShare = (platform) => {
    let url = '';
    
    switch (platform) {
      case 'whatsapp':
        url = `https://wa.me/?text=${encodeURIComponent(`${shareTitle}\n\n${shareText}\n\n${shareUrl}`)}`;
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}`;
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
        break;
      case 'copy':
        navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        return;
      default:
        return;
    }
    
    window.open(url, '_blank', 'width=600,height=400');
  };

  const buttonBaseClass = variant === 'compact' 
    ? 'w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200'
    : 'w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200';

  const buttons = [
    {
      platform: 'whatsapp',
      icon: MessageCircle,
      label: 'WhatsApp',
      bgClass: 'bg-[#25D366]/10 hover:bg-[#25D366]/20 text-[#25D366]',
    },
    {
      platform: 'twitter',
      icon: Twitter,
      label: 'Twitter',
      bgClass: 'bg-slate-500/10 hover:bg-slate-500/20 text-slate-400',
    },
    {
      platform: 'facebook',
      icon: Facebook,
      label: 'Facebook',
      bgClass: 'bg-[#1877F2]/10 hover:bg-[#1877F2]/20 text-[#1877F2]',
    },
    {
      platform: 'linkedin',
      icon: Linkedin,
      label: 'LinkedIn',
      bgClass: 'bg-[#0A66C2]/10 hover:bg-[#0A66C2]/20 text-[#0A66C2]',
    },
    {
      platform: 'copy',
      icon: copied ? Check : Link2,
      label: copied ? (language === 'es' ? 'Copiado' : 'Copied') : (language === 'es' ? 'Copiar enlace' : 'Copy link'),
      bgClass: copied 
        ? 'bg-emerald-500/20 text-emerald-400' 
        : 'bg-cyan-500/10 hover:bg-cyan-500/20 text-cyan-400',
    },
  ];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {variant !== 'compact' && (
        <span className="text-sm text-slate-500 mr-2">
          {language === 'es' ? 'Compartir:' : 'Share:'}
        </span>
      )}
      {buttons.map(({ platform, icon: Icon, label, bgClass }) => (
        <button
          key={platform}
          onClick={() => handleShare(platform)}
          className={`${buttonBaseClass} ${bgClass}`}
          title={label}
          aria-label={label}
          data-testid={`share-${platform}-btn`}
        >
          <Icon className={variant === 'compact' ? 'w-4 h-4' : 'w-5 h-5'} />
        </button>
      ))}
    </div>
  );
};
